<template>
    <div>
        <v-container>

            <InscriptionsFilters v-model="display_params" :mode="mode" :course-select="course_select"
                :billetterie-mode="mainStore.billetterie_mode" />
            <div class="d-flex justify-end align-center">
                <div class="text-body-1 font-weight-bold">{{ get_count_participants() }}</div>
            </div>

        </v-container>
        <v-table density="compact" v-if="courses_by_id">
            <BilletterieInscriptionThead :mode="mode" v-if="mainStore.billetterie_mode"></BilletterieInscriptionThead>
            <InscriptionThead v-else :mode="mode" :display_categorie_coureur="display_categorie_coureur">
            </InscriptionThead>

            <BilletterieInscriptionTbody :mode="mode" :inscriptions="inscriptions" :key="'bil' + update_key"
                v-if="mainStore.billetterie_mode">
            </BilletterieInscriptionTbody>
            <InscriptionTbody v-else :mode="mode" :inscriptions="inscriptions" :key="'ins' + update_key"
                :display_categorie_coureur="display_categorie_coureur" :courses_by_id="courses_by_id"
                @onValidPPS="loadList">
            </InscriptionTbody>

        </v-table>
        <div class="d-flex justify-end">
            <v-pagination density="compact" v-model="page" :length="get_length_pagination()"
                :total-visible="7"></v-pagination>
        </div>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import AdminService from "@/services/admin.service";
import axios from "axios";
import BilletterieInscriptionThead from "@/components/ListInscriptions/BilletterieInscriptionThead.vue";
import InscriptionThead from "@/components/ListInscriptions/InscriptionThead.vue";
import BilletterieInscriptionTbody from "@/components/ListInscriptions/BilletterieInscriptionTbody.vue";
import InscriptionTbody from "@/components/ListInscriptions/InscriptionTbody.vue";
import InscriptionsFilters from "@/components/ListInscriptions/InscriptionsFilters.vue";


export default {
    components: {
        InscriptionsFilters,
        BilletterieInscriptionThead,
        InscriptionThead,
        BilletterieInscriptionTbody,
        InscriptionTbody,
    },
    props: ["mode"],
    data() {
        return {

            update_key: 0,
            base_url: process.env.VUE_APP_API_BASE,
            dialog: false,
            page: 1,
            display_params: {
                search_value: "",
                search_by: "nom",
                id_course: 0,
                page: 1,
                perPage: 30,
                sexe: "",
                categorie: "",
                hide_deleted: false,
                show_only_deleted: false,
                order_by: "dossard",
                order_dir: "ASC",
            },
            count_match_query: 0,
            inscriptions: [],
            courses: [],
        };
    },
    watch: {
        display_params: {
            handler: function () {
                this.page = 1;
                this.loadList();
            },
            deep: true,
        },
        page() {
            this.loadList();
        },
    },
    computed: {
        ...mapStores(useMainStore),

        courses_by_id() {
            let courses = {};
            this.courses.forEach((course) => {
                courses[course.id] = course;
            });
            return courses;
        },
        course_select() {
            let res = [{ text: "Tous", value: 0 }];
            let courses = this.courses.map((course) => {
                return {
                    text: course.nom,
                    value: course.id,
                };
            });
            return res.concat(courses);
        },
        display_categorie_coureur() {
            if (this.display_params.id_course == 0) {
                return true;
            }
            let selected_course = this.courses_by_id[this.display_params.id_course];
            for (let i = 0; i < selected_course.metadatas.length; i++) {
                if (selected_course.metadatas[i].nom == "est_chronometre" && selected_course.metadatas[i].valeur == "0") {
                    return false;
                }
            }
            return true;
        },
    },
    methods: {

        get_length_pagination() {
            return Math.ceil(this.count_match_query / this.display_params.perPage);
        },
        get_count_participants() {
            if (this.inscriptions.length == 0) return "0 participant(s)";
            let current_page_offset = (this.display_params.page - 1) * this.display_params.perPage + 1;
            let current_page_count = current_page_offset + this.inscriptions.length - 1;
            return current_page_offset + " à " + current_page_count + " / " + this.count_match_query + " participants";
        },

        async loadCourses() {
            let res = await axios.get("/courses/get.php?id_module=" + this.mainStore.module.id);

            if (res.data.error) {
                console.log(res.data.error);
                return await false;
            } else {
                this.courses = res.data;
                return await true;
            }
        },
        async loadList() {
            let params = this.get_request_params();
            let res = await AdminService.getPreInscriptions(params);
            if (!res) {
                console.log(res.data.error);
                this.update_key++;
                return await false;
            } else {
                this.inscriptions = res.list;
                this.count_match_query = res.count_match_query;
                this.update_key++;
                return await true;
            }
        },
        get_request_params() {
            let params = "";
            params += "id_module=" + this.mainStore.module.id;
            const searchVal = this.display_params.search_value || "";
            if (searchVal != "") {
                if (this.display_params.search_by == "search_commande") {
                    params += "&search_commande=" + searchVal;
                } else if (this.display_params.search_by == "mail") {
                    params += "&search_mail=" + searchVal;
                } else {
                    params += "&search=" + searchVal;
                }
            }
            if (this.display_params.id_course != 0) {
                params += "&id_course=" + this.display_params.id_course;
            }
            if (this.page != 1) {
                params += "&page=" + this.page;
            }
            if (this.display_params.order_by != "nom") {
                params += "&order_by=" + this.display_params.order_by;
            }
            if (this.display_params.sexe != "") {
                params += "&sexe=" + this.display_params.sexe;
            }
            if (this.display_params.categorie != "") {
                params += "&categorie=" + this.display_params.categorie;
                params += "&event_date=" + this.mainStore.module.evenement.date_debut;
            }
            if (this.display_params.order_dir != "ASC") {
                params += "&order_dir=" + this.display_params.order_dir;
            }
            if (this.mode == "admin") {
                params += "&admin=1";
            }
            if (this.display_params.hide_deleted) {
                params += "&hide_deleted=1";
            }
            if (this.display_params.show_only_deleted) {
                params += "&show_only_deleted=1";
            }
            return params;
        },
    },
    async mounted() {

        await this.loadCourses();
        await this.loadList();


    }

}
</script>

<style lang="scss" scoped></style>